import { Box } from 'reflexbox';
import styled from 'styled-components';

import { ChevronRightIcon } from '@treams/treams-icons';
import { Heading, Join, Skeleton } from '@treams/treams-ui';
import { Link } from '@treams/treams-routes';

const Chevron = styled(Box)`
	svg {
		display: block;
		width: 24px;
		height: 24px;

		path {
			fill: ${(props) => props.theme.colors.slateBlue};
		}
	}
`;

const Component = styled(Heading)`
	cursor: pointer;
	border-bottom: 2px solid ${(props) => props.theme.colors.lightBlueDark};
	margin-bottom: -2px;
	white-space: pre;
	overflow: hidden;
	text-overflow: ellipsis;

	&:hover {
		background: ${(props) => props.theme.colors.lightBlue};
		border-bottom: none;
		padding: 5px;
		margin: -5px;
		border-radius: 5px;

		&:active {
			background: ${(props) => props.theme.colors.lightBlueDark};
		}
	}
`;

const Last = styled(Heading)`
	white-space: pre;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export default function Breadcrumbs(props: {
	components: { id: string; to?: string; name: string; readOnly?: boolean }[];
	onChange?: (id: string) => void;
}) {
	return (
		<Join
			alignItems="center"
			separator={
				<Chevron flexGrow={0} flexShrink={0}>
					<ChevronRightIcon />
				</Chevron>
			}
		>
			{props.components.map(({ id, to, name, readOnly }, index) =>
				index === props.components.length - 1 || readOnly === true ? (
					<Last key={id} flexShrink={0} flexGrow={0}>
						{name}
					</Last>
				) : to ? (
					<Link to={to} key={id}>
						<Component flexGrow={0} flexShrink={1}>
							{name}
						</Component>
					</Link>
				) : (
					<Component
						key={id}
						onClick={() => id && props.onChange && props.onChange(id)}
						flexGrow={0}
						flexShrink={1}
					>
						{name}
					</Component>
				),
			)}
		</Join>
	);
}

Breadcrumbs.Skeleton = styled(Skeleton.Box)`
	width: 200px;
	height: 24px;
`;
